export default {
  en: {
    get: {
      title: 'The resource could not be loaded | The resources could not be loaded',
      description: 'Please try again clicking in reload button for load {entity}.',
    },
    post: {
      title: 'Could not create the {entity}',
      description: 'Please try create again.',
    },
    patch: {
      title: 'Could not edit the {entity}',
      description: 'Please try edit again',
    },
    delete: {
      title: 'Could not delete the {entity}',
      description: 'Please try delete again.',
    },
    generic: {
      title: 'We have detected an error in the {entity}',
      description: 'Please try again otherwise contact us',
    },
    networkError: 'Network error',
    errorLoading: 'Error loading',
    checkFields: 'Fix wrong fields',
    unexpectedError: 'Unexpected error',
  },
  es: {
    get: {
      title: 'No se ha podido cargar el recurso | No se han podido cargar los recursos',
      description: 'Intente nuevamente haciendo clic en recargar para cargar.',
    },
    post: {
      title: 'No se ha podido crear el {entity} | No se han podido crear los {entity}',
      description: 'Intente crear nuevamente.',
    },
    patch: {
      title: 'No se ha podido editar el {entity} | No se han podido editar los {entity}',
      description: 'Intente editar nuevamente.',
    },
    delete: {
      title: 'No se ha podido eliminar el {entity} | No se han podido eliminar los {entity}',
      description: 'Intente eliminar nuevamente.',
    },
    generic: {
      title: 'Hemos detectado un error en el/la {entity}',
      description: 'Inténtalo de nuevo de lo contrario contáctanos',
    },
    networkError: 'Error de red',
    errorLoading: 'Error cargando',
    checkFields: 'Corrige los campos con errores',
    unexpectedError: 'Error inesperado',
  },
  fr: {
    get: {
      title: 'La ressource n\'a pas pu être chargée | Les ressources n\'ont pas pu être chargées',
      description: 'Veuillez réessayer en cliquant sur le bouton de rechargement pour charger {entity}.',
    },
    post: {
      title: 'Impossible de créer le {entity}',
      description: 'Veuillez réessayer de créer.',
    },
    patch: {
      title: 'Impossible de modifier le {entity}',
      description: 'Veuillez réessayer de modifier.',
    },
    delete: {
      title: 'Impossible de supprimer le {entity}',
      description: 'Veuillez réessayer de supprimer.',
    },
    generic: {
      title: 'Nous avons détecté une erreur dans le {entity}',
      description: 'Veuillez réessayer, sinon contactez-nous.',
    },
    networkError: 'Erreur réseau',
    errorLoading: 'Erreur de chargement',
    checkFields: 'Corrigez les champs incorrects',
    unexpectedError: 'Erreur inattendue',
}

};
